import { registerQuery } from 'data-fetching-client';
import { getAudience } from 'audiences-data/api';
import { FIELD_NAME } from '../constants/fieldName';
export const AUDIENCE_DETAILS_QUERY = registerQuery({
  fieldName: FIELD_NAME.AUDIENCE_DETAILS,
  args: ['audienceId'],
  fetcher: query => getAudience(query.audienceId)
});